export default "__VITE_ASSET__9ec38055__"